import { FieldsList as FieldsListLanguage } from '../../../../i18n'
import LanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { AvailableStatisticsFieldsArray } from './Types'

export type AddMenuItem = {
    name?: string
    title?: string
    subMenuItems?: AddMenuItem[]
    statIds?: number[]
    customClass?: string
}

type StatsCategories = {
    contactCounts: number[]
    contactCountsAnsThres: number[]
    contactCountsAbandonThres: number[]
    contactCountsVoice: number[]
    contactCountsVoiceAnsThres: number[]
    contactCountsVoiceAbandonThres: number[]
    contactCountsExternalInboundExtensionCalls: number[]
    contactCountsExternalInboundACDCalls: number[]
    contactCountsExternalInboundNonACDCalls: number[]
    contactCountsExternalInboundOtherCalls: number[]
    contactCountsExternalInboundCalls: number[]
    contactCountsVoiceExternalInboundExtensionCalls: number[]
    contactCountsVoiceExternalInboundACDCalls: number[]
    contactCountsVoiceExternalInboundNonACDCalls: number[]
    contactCountsVoiceExternalInboundOtherCalls: number[]
    contactCountsVoiceExternalInboundCalls: number[]
    contactCountsChat: number[]
    contactCountsChatAnsThres: number[]
    contactCountsChatAbndThres: number[]
    contactCountsEmail: number[]
    contactCountsEmailAnsThres: number[]

    contactPercentages: number[]
    contactPercentagesAnsThres: number[]
    contactPercentagesAbandonedThres: number[]
    contactPercentagesVoice: number[]
    contactPercentagesVoiceAnsThres: number[]
    contactPercentagesVoiceAbandonedThres: number[]
    contactPercentagesExternalInboundExtensionCalls: number[]
    contactPercentagesExternalInboundACDCalls: number[]
    contactPercentagesExternalInboundNonACDCalls: number[]
    contactPercentagesExternalInboundOtherCalls: number[]
    contactPercentagesExternalInboundCalls: number[]
    contactPercentagesVoiceExternalInboundExtensionCalls: number[]
    contactPercentagesVoiceExternalInboundACDCalls: number[]
    contactPercentagesVoiceExternalInboundNonACDCalls: number[]
    contactPercentagesVoiceExternalInboundOtherCalls: number[]
    contactPercentagesVoiceExternalInboundCalls: number[]
    contactPercentagesChat: number[]
    contactPercentagesChatAnsThres: number[]
    contactPercentagesChatAbndThres: number[]
    contactPercentagesEmail: number[]
    contactPercentagesEmailAnsThres: number[]

    contactTimes: number[]
    contactTimesInbound: number[]
    contactTimesOutbound: number[]
    contactTimesVoice: number[]
    contactTimesVoiceInbound: number[]
    contactTimesVoiceOutbound: number[]
    contactTimesExternalInboundACDCalls: number[]
    contactTimesExternalInboundNonACDCalls: number[]
    contactTimesExternalInboundCalls: number[]
    contactTimesExternalInboundOtherCalls: number[]
    contactTimesExternalInboundDDICalls: number[]
    contactTimesVoiceExternalInboundACDCalls: number[]
    contactTimesVoiceExternalInboundNonACDCalls: number[]
    contactTimesVoiceExternalInboundCalls: number[]
    contactTimesVoiceExternalInboundOtherCalls: number[]
    contactTimesVoiceExternalInboundDDICalls: number[]
    contactTimesChat: number[]
    contactTimesChatInbound: number[]
    contactTimesEmail: number[]
    contactTimesEmailInbound: number[]

    financial: number[]
    financialVoice: number[]
    financialChat: number[]
    financialEmail: number[]

    ACDCounts: number[]
    ACDCountsBusyCounts: number[]
    ACDCountsNotAvailableCodeCounts: number[]
    ACDPercentages: number[]

    ACDTimes: number[]
    ACDTimesBusyTimes: number[]
    ACDTimesNotAvailableCodeTimes: number[]

    DNDStatistics: number[]
    totalFraudDetection: number[]
    reportSettings: number[]
    userContent: number[]
    miscellaneous: number[]
    diagnosticValues: number[]

    general: number[]
    generalCall: number[]
    deviceCall: number[]
    agentCall: number[]
    activeCall: number[]
    states: number[]
}

enum Categories {
    CONTACT_COUNTS = 30,
    CONTACT_COUNTS_INBOUND_ANS_THRES = 34,
    CONTACT_COUNTS_VOICE = 1030,
    CONTACT_COUNTS_VOICE_ANS_THRES = 1034,
    CONTACT_COUNTS_VOICE_ABANDONED_THRES = 1035,
    CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_EXTENSIONCALLS = 1033,
    CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_ACDCALLS = 1036,
    CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_NONACDCALLS = 1037,
    CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_CALLS = 1038,
    CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_OTHERCALLS = 1039,

    CONTACT_PERCENTAGES = 40,
    CONTACT_PERCENTAGES_ANS_THRES = 44,
    CONTACT_PERCENTAGES_VOICE = 1040,
    CONTACT_PERCENTAGES_VOICE_ANS_THRES = 1044,
    CONTACT_PERCENTAGES_VOICE_ABANDONED_THRES = 1045,
    CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_EXTENSIONCALLS = 1049,
    CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_ACDCALLS = 1046,
    CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_NONACDCALLS = 1047,
    CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_OTHERCALLS = 1050,
    CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_CALLS = 1048,

    CONTACT_TIMES = 51,
    CONTACT_TIMES_INBOUND = 53,
    CONTACT_TIMES_OUTBOUND = 54,
    CONTACT_TIMES_VOICE = 1051,
    CONTACT_TIMES_VOICE_INBOUND = 1053,
    CONTACT_TIMES_VOICE_INBOUND_EXTERNAL_INBOUND_ACDCALLS = 1055,
    CONTACT_TIMES_VOICE_INBOUND_EXTERNAL_INBOUND_NONACDCALLS = 1056,
    CONTACT_TIMES_VOICE_INBOUND_EXTERNAL_INBOUND_CALLS = 1057,
    CONTACT_TIMES_VOICE_EXTERNAL_INBOUND_OTHER_CALLS = 1058,
    CONTACT_TIMES_VOICE_EXTERNAL_INBOUND_EXTENSION_CALLS = 1059,
    CONTACT_TIMES_VOICE_OUTBOUND = 1054,

    FINANCIAL = 70,
    FINANCIAL_VOICE = 1070,

    ACD_COUNTS = 31,
    ACD_COUNTS_BUSY_COUNTS = 35,
    ACD_COUNTS_NOT_AVAILABLE_CODE_COUNTS = 32,
    PERCENTAGES_ACD = 41,

    ACD_TIMES = 52,
    ACD_TIMES_BUSY_TIMES = 56,
    ACD_TIMES_NOT_AVAILABLE_CODE_TIMES = 55,

    TOTAL_FRAUD_DETECTION = 60,
    TOTAL_FRAUD_TIMES = 61,

    DND_STATISTICS = 33,
    REPORT_SETTINGS = 10,

    USER_CONTENT = 6,

    MISCELLANEOUS = 5,
    STAT_UNKNOWN = -1,
    STAT_NONE = 0,
    TITLE_ITEMDETAILS = 100,

    DIAGNOSTIC_VALUES = 13,

    GENERAL = 11,
    STATES = 12,
    CALL_GENERAL = 20,
    CALL_DEVICE = 21,
    CALL_AGENT = 22,
    CALL_ACTIVE = 23
}

const buildCategories = (statsList: AvailableStatisticsFieldsArray): StatsCategories => {
    const contactCounts = [] as number[]
    const contactCountsAnsThres = [] as number[]
    const contactCountsAbandonThres = [] as number[]
    const contactCountsVoice = [] as number[]
    const contactCountsVoiceAnsThres = [] as number[]
    const contactCountsVoiceAbandonThres = [] as number[]
    const contactCountsExternalInboundExtensionCalls = [] as number[]
    const contactCountsExternalInboundACDCalls = [] as number[]
    const contactCountsExternalInboundNonACDCalls = [] as number[]
    const contactCountsExternalInboundOtherCalls = [] as number[]
    const contactCountsExternalInboundCalls = [] as number[]
    const contactCountsVoiceExternalInboundExtensionCalls = [] as number[]
    const contactCountsVoiceExternalInboundACDCalls = [] as number[]
    const contactCountsVoiceExternalInboundNonACDCalls = [] as number[]
    const contactCountsVoiceExternalInboundOtherCalls = [] as number[]
    const contactCountsVoiceExternalInboundCalls = [] as number[]
    const contactCountsChat = [] as number[]
    const contactCountsChatAnsThres = [] as number[]
    const contactCountsChatAbndThres = [] as number[]
    const contactCountsEmail = [] as number[]
    const contactCountsEmailAnsThres = [] as number[]

    const contactPercentages = [] as number[]
    const contactPercentagesAnsThres = [] as number[]
    const contactPercentagesAbandonedThres = [] as number[]
    const contactPercentagesVoice = [] as number[]
    const contactPercentagesVoiceAnsThres = [] as number[]
    const contactPercentagesVoiceAbandonedThres = [] as number[]
    const contactPercentagesExternalInboundExtensionCalls = [] as number[]
    const contactPercentagesExternalInboundACDCalls = [] as number[]
    const contactPercentagesExternalInboundNonACDCalls = [] as number[]
    const contactPercentagesExternalInboundOtherCalls = [] as number[]
    const contactPercentagesExternalInboundCalls = [] as number[]
    const contactPercentagesVoiceExternalInboundExtensionCalls = [] as number[]
    const contactPercentagesVoiceExternalInboundACDCalls = [] as number[]
    const contactPercentagesVoiceExternalInboundNonACDCalls = [] as number[]
    const contactPercentagesVoiceExternalInboundOtherCalls = [] as number[]
    const contactPercentagesVoiceExternalInboundCalls = [] as number[]
    const contactPercentagesChat = [] as number[]
    const contactPercentagesChatAnsThres = [] as number[]
    const contactPercentagesChatAbndThres = [] as number[]
    const contactPercentagesEmail = [] as number[]
    const contactPercentagesEmailAnsThres = [] as number[]

    const contactTimes = [] as number[]
    const contactTimesInbound = [] as number[]
    const contactTimesOutbound = [] as number[]
    const contactTimesVoice = [] as number[]
    const contactTimesVoiceInbound = [] as number[]
    const contactTimesVoiceOutbound = [] as number[]
    const contactTimesExternalInboundACDCalls = [] as number[]
    const contactTimesExternalInboundNonACDCalls = [] as number[]
    const contactTimesExternalInboundCalls = [] as number[]
    const contactTimesExternalInboundOtherCalls = [] as number[]
    const contactTimesExternalInboundDDICalls = [] as number[]
    const contactTimesVoiceExternalInboundACDCalls = [] as number[]
    const contactTimesVoiceExternalInboundNonACDCalls = [] as number[]
    const contactTimesVoiceExternalInboundCalls = [] as number[]
    const contactTimesVoiceExternalInboundOtherCalls = [] as number[]
    const contactTimesVoiceExternalInboundDDICalls = [] as number[]
    const contactTimesChat = [] as number[]
    const contactTimesChatInbound = [] as number[]
    const contactTimesEmail = [] as number[]
    const contactTimesEmailInbound = [] as number[]

    const financial = [] as number[]
    const financialVoice = [] as number[]
    const financialChat = [] as number[]
    const financialEmail = [] as number[]

    const ACDCounts = [] as number[]
    const ACDCountsBusyCounts = [] as number[]
    const ACDCountsNotAvailableCodeCounts = [] as number[]
    const ACDPercentages = [] as number[]

    const ACDTimes = [] as number[]
    const ACDTimesBusyTimes = [] as number[]
    const ACDTimesNotAvailableCodeTimes = [] as number[]

    const DNDStatistics = [] as number[]
    const totalFraudDetection = [] as number[]
    const reportSettings = [] as number[]
    const userContent = [] as number[]
    const miscellaneous = [] as number[]
    const diagnosticValues = [] as number[]

    const general = [] as number[]
    const generalCall = [] as number[]
    const deviceCall = [] as number[]
    const agentCall = [] as number[]
    const activeCall = [] as number[]
    const states = [] as number[]

    statsList.forEach((stat) => {
        switch (stat.Category) {
            case Categories.REPORT_SETTINGS:
                reportSettings.push(stat.StatID)
                break
            case Categories.GENERAL:
                general.push(stat.StatID)
                break
            case Categories.USER_CONTENT:
                userContent.push(stat.StatID)
                break
            case Categories.STATES:
                states.push(stat.StatID)
                break
            case Categories.DIAGNOSTIC_VALUES:
                diagnosticValues.push(stat.StatID)
                break
            case Categories.CALL_GENERAL:
                generalCall.push(stat.StatID)
                break
            case Categories.CALL_ACTIVE:
                activeCall.push(stat.StatID)
                break
            case Categories.CALL_DEVICE:
                deviceCall.push(stat.StatID)
                break
            case Categories.CALL_AGENT:
                agentCall.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS:
                contactCounts.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_VOICE:
                contactCounts.push(stat.StatID)
                break
            case Categories.ACD_COUNTS:
                ACDCounts.push(stat.StatID)
                break
            case Categories.ACD_COUNTS_NOT_AVAILABLE_CODE_COUNTS:
                ACDCountsNotAvailableCodeCounts.push(stat.StatID)
                break
            case Categories.ACD_COUNTS_BUSY_COUNTS:
                ACDCountsBusyCounts.push(stat.StatID)
                break
            case Categories.DND_STATISTICS:
                DNDStatistics.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_INBOUND_ANS_THRES:
                contactCountsAnsThres.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_VOICE_ANS_THRES:
                contactCountsAnsThres.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_VOICE_ABANDONED_THRES:
                contactCountsAbandonThres.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_EXTENSIONCALLS:
                contactCountsExternalInboundExtensionCalls.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_ACDCALLS:
                contactCountsExternalInboundACDCalls.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_NONACDCALLS:
                contactCountsExternalInboundNonACDCalls.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_OTHERCALLS:
                contactCountsExternalInboundOtherCalls.push(stat.StatID)
                break
            case Categories.CONTACT_COUNTS_VOICE_EXTERNAL_INBOUND_CALLS:
                contactCountsExternalInboundCalls.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES:
                contactPercentages.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_VOICE:
                contactPercentages.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_EXTENSIONCALLS:
                contactPercentagesExternalInboundExtensionCalls.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_ACDCALLS:
                contactPercentagesExternalInboundACDCalls.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_NONACDCALLS:
                contactPercentagesExternalInboundNonACDCalls.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_OTHERCALLS:
                contactPercentagesExternalInboundOtherCalls.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_VOICE_EXTERNAL_INBOUND_CALLS:
                contactPercentagesExternalInboundCalls.push(stat.StatID)
                break
            case Categories.PERCENTAGES_ACD:
                ACDPercentages.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_ANS_THRES:
                contactPercentagesAnsThres.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_VOICE_ANS_THRES:
                contactPercentagesAnsThres.push(stat.StatID)
                break
            case Categories.CONTACT_PERCENTAGES_VOICE_ABANDONED_THRES:
                contactPercentagesAbandonedThres.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES:
                contactTimes.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_VOICE:
                contactTimes.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_VOICE_INBOUND_EXTERNAL_INBOUND_ACDCALLS:
                contactTimesExternalInboundACDCalls.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_VOICE_INBOUND_EXTERNAL_INBOUND_NONACDCALLS:
                contactTimesExternalInboundNonACDCalls.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_VOICE_INBOUND_EXTERNAL_INBOUND_CALLS:
                contactTimesExternalInboundCalls.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_VOICE_EXTERNAL_INBOUND_OTHER_CALLS:
                contactTimesExternalInboundOtherCalls.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_VOICE_EXTERNAL_INBOUND_EXTENSION_CALLS:
                contactTimesExternalInboundDDICalls.push(stat.StatID)
                break
            case Categories.ACD_TIMES:
                ACDTimes.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_INBOUND:
                contactTimesInbound.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_VOICE_INBOUND:
                contactTimesInbound.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_OUTBOUND:
                contactTimesOutbound.push(stat.StatID)
                break
            case Categories.CONTACT_TIMES_VOICE_OUTBOUND:
                contactTimesOutbound.push(stat.StatID)
                break
            case Categories.ACD_TIMES_NOT_AVAILABLE_CODE_TIMES:
                ACDTimesNotAvailableCodeTimes.push(stat.StatID)
                break
            case Categories.ACD_TIMES_BUSY_TIMES:
                ACDTimesBusyTimes.push(stat.StatID)
                break
            case Categories.FINANCIAL:
                financial.push(stat.StatID)
                break
            case Categories.FINANCIAL_VOICE:
                financial.push(stat.StatID)
                break
            case Categories.TOTAL_FRAUD_DETECTION:
            case Categories.TOTAL_FRAUD_TIMES:
                totalFraudDetection.push(stat.StatID)
                break
            case Categories.STAT_UNKNOWN:
            case Categories.STAT_NONE:
            case Categories.MISCELLANEOUS:
            case Categories.TITLE_ITEMDETAILS:
            default:
                miscellaneous.push(stat.StatID)
        }
    })

    return {
        contactCounts,
        contactCountsAnsThres,
        contactCountsAbandonThres,
        contactCountsVoice,
        contactCountsVoiceAnsThres,
        contactCountsVoiceAbandonThres,
        contactCountsExternalInboundExtensionCalls,
        contactCountsExternalInboundACDCalls,
        contactCountsExternalInboundNonACDCalls,
        contactCountsExternalInboundOtherCalls,
        contactCountsExternalInboundCalls,
        contactCountsVoiceExternalInboundExtensionCalls,
        contactCountsVoiceExternalInboundACDCalls,
        contactCountsVoiceExternalInboundNonACDCalls,
        contactCountsVoiceExternalInboundOtherCalls,
        contactCountsVoiceExternalInboundCalls,
        contactCountsChat,
        contactCountsChatAnsThres,
        contactCountsChatAbndThres,
        contactCountsEmail,
        contactCountsEmailAnsThres,

        contactPercentages,
        contactPercentagesAnsThres,
        contactPercentagesAbandonedThres,
        contactPercentagesVoice,
        contactPercentagesVoiceAnsThres,
        contactPercentagesVoiceAbandonedThres,
        contactPercentagesExternalInboundExtensionCalls,
        contactPercentagesExternalInboundACDCalls,
        contactPercentagesExternalInboundNonACDCalls,
        contactPercentagesExternalInboundOtherCalls,
        contactPercentagesExternalInboundCalls,
        contactPercentagesVoiceExternalInboundExtensionCalls,
        contactPercentagesVoiceExternalInboundACDCalls,
        contactPercentagesVoiceExternalInboundNonACDCalls,
        contactPercentagesVoiceExternalInboundOtherCalls,
        contactPercentagesVoiceExternalInboundCalls,
        contactPercentagesChat,
        contactPercentagesChatAnsThres,
        contactPercentagesChatAbndThres,
        contactPercentagesEmail,
        contactPercentagesEmailAnsThres,

        contactTimes,
        contactTimesInbound,
        contactTimesOutbound,
        contactTimesVoice,
        contactTimesVoiceInbound,
        contactTimesExternalInboundACDCalls,
        contactTimesExternalInboundNonACDCalls,
        contactTimesExternalInboundCalls,
        contactTimesExternalInboundOtherCalls,
        contactTimesExternalInboundDDICalls,
        contactTimesVoiceExternalInboundACDCalls,
        contactTimesVoiceExternalInboundNonACDCalls,
        contactTimesVoiceExternalInboundCalls,
        contactTimesVoiceExternalInboundOtherCalls,
        contactTimesVoiceExternalInboundDDICalls,
        contactTimesVoiceOutbound,
        contactTimesChat,
        contactTimesChatInbound,
        contactTimesEmail,
        contactTimesEmailInbound,

        financial,
        financialVoice,
        financialChat,
        financialEmail,

        ACDCounts,
        ACDCountsBusyCounts,
        ACDCountsNotAvailableCodeCounts,
        ACDPercentages,

        ACDTimes,
        ACDTimesBusyTimes,
        ACDTimesNotAvailableCodeTimes,

        DNDStatistics,
        totalFraudDetection,
        reportSettings,
        userContent,
        miscellaneous,
        diagnosticValues,

        general,
        generalCall,
        deviceCall,
        agentCall,
        activeCall,
        states
    }
}

/**
 * Utility function to used to check whether the category should be included in the menu.
 * Only the categories with sub items that have statistics to render should be rendered in the menu.
 *
 * @param category The category to check sub items in.
 * @param listOfSubItemsToCheckIfNotEmpty The list of arrays of statistics to check whether not empty.
 *
 * @return Returns the list-wrapped category that can be added to the array using spread operator.
 */
const notEmptyCategory = (category: AddMenuItem, listOfSubItemsToCheckIfNotEmpty: number[][]): AddMenuItem[] | [] =>
    listOfSubItemsToCheckIfNotEmpty.some((subItems) => subItems.length > 0) ? [category] : []

export const buildMenuStructureFromAvailableStats = (
    language: LanguageHandler,
    statsList: AvailableStatisticsFieldsArray
): AddMenuItem[] => {
    const categories = buildCategories(statsList)

    // Categories with additional merging logic.
    let {
        contactCounts,
        contactCountsAnsThres,
        contactPercentages,
        contactPercentagesAnsThres,
        contactPercentagesEmail,
        contactPercentagesEmailAnsThres
    } = categories

    // Categories without merging changes.
    const {
        contactCountsAbandonThres,
        contactCountsVoice,
        contactCountsVoiceAnsThres,
        contactCountsVoiceAbandonThres,
        contactCountsExternalInboundExtensionCalls,
        contactCountsExternalInboundACDCalls,
        contactCountsExternalInboundNonACDCalls,
        contactCountsExternalInboundOtherCalls,
        contactCountsExternalInboundCalls,
        contactCountsVoiceExternalInboundExtensionCalls,
        contactCountsVoiceExternalInboundACDCalls,
        contactCountsVoiceExternalInboundNonACDCalls,
        contactCountsVoiceExternalInboundOtherCalls,
        contactCountsVoiceExternalInboundCalls,
        contactCountsChat,
        contactCountsChatAnsThres,
        contactCountsChatAbndThres,
        contactCountsEmail,
        contactCountsEmailAnsThres,

        contactPercentagesAbandonedThres,
        contactPercentagesVoice,
        contactPercentagesVoiceAnsThres,
        contactPercentagesVoiceAbandonedThres,
        contactPercentagesExternalInboundExtensionCalls,
        contactPercentagesExternalInboundACDCalls,
        contactPercentagesExternalInboundNonACDCalls,
        contactPercentagesExternalInboundOtherCalls,
        contactPercentagesExternalInboundCalls,
        contactPercentagesVoiceExternalInboundExtensionCalls,
        contactPercentagesVoiceExternalInboundACDCalls,
        contactPercentagesVoiceExternalInboundNonACDCalls,
        contactPercentagesVoiceExternalInboundOtherCalls,
        contactPercentagesVoiceExternalInboundCalls,
        contactPercentagesChat,
        contactPercentagesChatAnsThres,
        contactPercentagesChatAbndThres,

        contactTimes,
        contactTimesInbound,
        contactTimesOutbound,
        contactTimesVoice,
        contactTimesVoiceInbound,
        contactTimesExternalInboundACDCalls,
        contactTimesExternalInboundNonACDCalls,
        contactTimesExternalInboundCalls,
        contactTimesExternalInboundOtherCalls,
        contactTimesExternalInboundDDICalls,
        contactTimesVoiceExternalInboundACDCalls,
        contactTimesVoiceExternalInboundNonACDCalls,
        contactTimesVoiceExternalInboundCalls,
        contactTimesVoiceExternalInboundOtherCalls,
        contactTimesVoiceExternalInboundDDICalls,
        contactTimesVoiceOutbound,
        contactTimesChat,
        contactTimesChatInbound,
        contactTimesEmail,
        contactTimesEmailInbound,

        financial,
        financialVoice,
        financialChat,
        financialEmail,

        ACDCounts,
        ACDCountsBusyCounts,
        ACDCountsNotAvailableCodeCounts,
        ACDPercentages,

        ACDTimes,
        ACDTimesBusyTimes,
        ACDTimesNotAvailableCodeTimes,

        DNDStatistics,
        totalFraudDetection,
        reportSettings,
        userContent,
        miscellaneous,
        diagnosticValues,

        general,
        generalCall,
        deviceCall,
        agentCall,
        activeCall,
        states
    } = categories

    if (contactCounts.length === 0 && contactCountsAnsThres.length > 0) {
        // Merge categories as the parent one is empty.
        contactCounts = contactCountsAnsThres
        contactCountsAnsThres = []
    }
    if (contactPercentages.length === 0 && contactPercentagesAnsThres.length > 0) {
        // Merge categories as the parent one is empty.
        contactPercentages = contactPercentagesAnsThres
        contactPercentagesAnsThres = []
    }
    if (contactPercentagesEmail.length === 0 && contactPercentagesEmailAnsThres.length > 0) {
        // Merge categories as the parent one is empty.
        contactPercentagesEmail = contactPercentagesEmailAnsThres
        contactPercentagesEmailAnsThres = []
    }

    return [
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuGeneralName),
                title: language?.get(FieldsListLanguage.CategorySubmenuGeneralTitle),
                subMenuItems: [{ statIds: general }]
            },
            [general]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuGeneralCallName),
                title: language?.get(FieldsListLanguage.CategorySubmenuGeneralCallTitle),
                subMenuItems: [{ statIds: generalCall }]
            },
            [generalCall]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuActiveCallName),
                title: language?.get(FieldsListLanguage.CategorySubmenuActiveCallTitle),
                subMenuItems: [{ statIds: activeCall }]
            },
            [activeCall]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuDeviceCallName),
                title: language?.get(FieldsListLanguage.CategorySubmenuDeviceCallTitle),
                subMenuItems: [{ statIds: deviceCall }]
            },
            [deviceCall]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuAgentCallName),
                title: language?.get(FieldsListLanguage.CategorySubmenuAgentCallTitle),
                subMenuItems: [{ statIds: agentCall }]
            },
            [agentCall]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuContactCountsName),
                title: language?.get(FieldsListLanguage.CategorySubmenuContactCountsTitle),
                customClass: 'contact-counts-menu-entry',
                subMenuItems: [
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactCountsAnsThresName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactCountsAnsThresTitle),
                            subMenuItems: [{ statIds: contactCountsAnsThres }]
                        },
                        [contactCountsAnsThres]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactCountsAbndThresName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactCountsAbndThresTitle),
                            subMenuItems: [{ statIds: contactCountsAbandonThres }]
                        },
                        [contactCountsAbandonThres]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundExtensionCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundExtensionCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactCountsExternalInboundExtensionCalls }]
                        },
                        [contactCountsExternalInboundExtensionCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundACDCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundACDCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactCountsExternalInboundACDCalls }]
                        },
                        [contactCountsExternalInboundACDCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundNonACDCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundNonACDCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactCountsExternalInboundNonACDCalls }]
                        },
                        [contactCountsExternalInboundNonACDCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundOtherCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundOtherCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactCountsExternalInboundOtherCalls }]
                        },
                        [contactCountsExternalInboundOtherCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundCallsName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundCallsTitle),
                            subMenuItems: [{ statIds: contactCountsExternalInboundCalls }]
                        },
                        [contactCountsExternalInboundCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactCountsVoiceName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactCountsVoiceTitle),
                            customClass: 'contact-counts-voice-menu-entry',
                            subMenuItems: [
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceAnsThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceAnsThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsVoiceAnsThres }]
                                    },
                                    [contactCountsVoiceAnsThres]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceAbndThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceAbndThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsVoiceAbandonThres }]
                                    },
                                    [contactCountsVoiceAbandonThres]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundExtensionCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundExtensionCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsVoiceExternalInboundExtensionCalls }]
                                    },
                                    [contactCountsVoiceExternalInboundExtensionCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundACDCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundACDCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsVoiceExternalInboundACDCalls }]
                                    },
                                    [contactCountsVoiceExternalInboundACDCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundNonACDCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundNonACDCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsVoiceExternalInboundNonACDCalls }]
                                    },
                                    [contactCountsVoiceExternalInboundNonACDCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundOtherCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundOtherCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsVoiceExternalInboundOtherCalls }]
                                    },
                                    [contactCountsVoiceExternalInboundOtherCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsVoiceInboundCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsVoiceExternalInboundCalls }]
                                    },
                                    [contactCountsVoiceExternalInboundCalls]
                                ),
                                { statIds: contactCountsVoice }
                            ]
                        },
                        [
                            contactCountsVoiceAnsThres,
                            contactCountsVoice,
                            contactCountsVoiceExternalInboundExtensionCalls,
                            contactCountsVoiceExternalInboundACDCalls,
                            contactCountsVoiceExternalInboundNonACDCalls,
                            contactCountsVoiceExternalInboundOtherCalls,
                            contactCountsVoiceExternalInboundCalls
                        ]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactCountsChatName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactCountsChatTitle),
                            subMenuItems: [
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsChatAnsThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsChatAnsThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsChatAnsThres }]
                                    },
                                    [contactCountsChatAnsThres]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsChatAbndThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsChatAbndThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsChatAbndThres }]
                                    },
                                    [contactCountsChatAbndThres]
                                ),
                                { statIds: contactCountsChat }
                            ]
                        },
                        [contactCountsChatAnsThres, contactCountsChat]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactCountsEmailName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactCountsEmailTitle),
                            subMenuItems: [
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsEmailAnsThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactCountsEmailAnsThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactCountsEmailAnsThres }]
                                    },
                                    [contactCountsEmailAnsThres]
                                ),
                                { statIds: contactCountsEmail }
                            ]
                        },
                        [contactCountsEmailAnsThres, contactCountsEmail]
                    ),
                    { statIds: contactCounts }
                ]
            },
            [
                contactCountsAnsThres,
                contactCounts,
                contactCountsVoiceAnsThres,
                contactCountsVoice,
                contactCountsChatAnsThres,
                contactCountsChat,
                contactCountsEmailAnsThres,
                contactCountsEmail,
                contactCountsExternalInboundExtensionCalls,
                contactCountsExternalInboundACDCalls,
                contactCountsExternalInboundNonACDCalls,
                contactCountsExternalInboundOtherCalls,
                contactCountsExternalInboundCalls,
                contactCountsVoiceExternalInboundExtensionCalls,
                contactCountsVoiceExternalInboundACDCalls,
                contactCountsVoiceExternalInboundNonACDCalls,
                contactCountsVoiceExternalInboundOtherCalls,
                contactCountsVoiceExternalInboundCalls
            ]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesName),
                title: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesTitle),
                subMenuItems: [
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesAnsThresName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesAnsThresTitle),
                            subMenuItems: [{ statIds: contactPercentagesAnsThres }]
                        },
                        [contactPercentagesAnsThres]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesAbndThresName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesAbndThresTitle),
                            subMenuItems: [{ statIds: contactPercentagesAbandonedThres }]
                        },
                        [contactPercentagesAbandonedThres]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundExtensionCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundExtensionCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactPercentagesExternalInboundExtensionCalls }]
                        },
                        [contactPercentagesExternalInboundExtensionCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundACDCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundACDCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactPercentagesExternalInboundACDCalls }]
                        },
                        [contactPercentagesExternalInboundACDCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundNonACDCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundNonACDCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactPercentagesExternalInboundNonACDCalls }]
                        },
                        [contactPercentagesExternalInboundNonACDCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundOtherCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundOtherCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactPercentagesExternalInboundOtherCalls }]
                        },
                        [contactPercentagesExternalInboundOtherCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundCallsName
                            ),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundCallsTitle
                            ),
                            subMenuItems: [{ statIds: contactPercentagesExternalInboundCalls }]
                        },
                        [contactPercentagesExternalInboundCalls]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesVoiceName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesVoiceTitle),
                            subMenuItems: [
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceAnsThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceAnsThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesVoiceAnsThres }]
                                    },
                                    [contactPercentagesVoiceAnsThres]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceAbndThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceAbndThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesVoiceAbandonedThres }]
                                    },
                                    [contactPercentagesVoiceAbandonedThres]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundExtensionCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundExtensionCallsTitle
                                        ),
                                        subMenuItems: [
                                            { statIds: contactPercentagesVoiceExternalInboundExtensionCalls }
                                        ]
                                    },
                                    [contactPercentagesVoiceExternalInboundExtensionCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundACDCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundACDCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesVoiceExternalInboundACDCalls }]
                                    },
                                    [contactPercentagesVoiceExternalInboundACDCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundNonACDCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundNonACDCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesVoiceExternalInboundNonACDCalls }]
                                    },
                                    [contactPercentagesVoiceExternalInboundNonACDCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundOtherCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundOtherCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesVoiceExternalInboundOtherCalls }]
                                    },
                                    [contactPercentagesVoiceExternalInboundOtherCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesVoiceInboundCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesVoiceExternalInboundCalls }]
                                    },
                                    [contactPercentagesVoiceExternalInboundCalls]
                                ),
                                { statIds: contactPercentagesVoice }
                            ]
                        },
                        [
                            contactPercentagesVoiceAnsThres,
                            contactPercentagesVoice,
                            contactPercentagesVoiceAbandonedThres,
                            contactPercentagesVoiceExternalInboundExtensionCalls,
                            contactPercentagesVoiceExternalInboundACDCalls,
                            contactPercentagesVoiceExternalInboundNonACDCalls,
                            contactPercentagesVoiceExternalInboundOtherCalls,
                            contactPercentagesVoiceExternalInboundCalls
                        ]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesChatName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesChatTitle),
                            subMenuItems: [
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesChatAnsThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesChatAnsThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesChatAnsThres }]
                                    },
                                    [contactPercentagesChatAnsThres]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesChatAbndThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesChatAbndThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesChatAbndThres }]
                                    },
                                    [contactPercentagesChatAbndThres]
                                ),
                                { statIds: contactPercentagesChat }
                            ]
                        },
                        [contactPercentagesChatAnsThres, contactPercentagesChat]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesEmailName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesEmailTitle),
                            subMenuItems: [
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesEmailAnsThresName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactPercentagesEmailAnsThresTitle
                                        ),
                                        subMenuItems: [{ statIds: contactPercentagesEmailAnsThres }]
                                    },
                                    [contactPercentagesEmailAnsThres]
                                ),
                                { statIds: contactPercentagesEmail }
                            ]
                        },
                        [contactPercentagesEmailAnsThres, contactPercentagesEmail]
                    ),
                    { statIds: contactPercentages }
                ]
            },
            [
                contactPercentagesAnsThres,
                contactPercentages,
                contactPercentagesVoiceAnsThres,
                contactPercentagesVoice,
                contactPercentagesChatAnsThres,
                contactPercentagesChat,
                contactPercentagesEmailAnsThres,
                contactPercentagesEmail,
                contactPercentagesVoiceAbandonedThres,
                contactPercentagesVoiceExternalInboundExtensionCalls,
                contactPercentagesVoiceExternalInboundACDCalls,
                contactPercentagesVoiceExternalInboundNonACDCalls,
                contactPercentagesVoiceExternalInboundOtherCalls,
                contactPercentagesVoiceExternalInboundCalls,
                contactCountsExternalInboundACDCalls,
                contactCountsExternalInboundNonACDCalls,
                contactCountsExternalInboundCalls
            ]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuContactTimesName),
                title: language?.get(FieldsListLanguage.CategorySubmenuContactTimesTitle),
                subMenuItems: [
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactTimesInboundName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactTimesInboundTitle),
                            subMenuItems: [
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundACDCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundACDCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactTimesExternalInboundACDCalls }]
                                    },
                                    [contactTimesExternalInboundACDCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundNonACDCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundNonACDCallsTitle
                                        ),
                                        subMenuItems: [
                                            {
                                                statIds: contactTimesExternalInboundNonACDCalls
                                            }
                                        ]
                                    },
                                    [contactTimesExternalInboundNonACDCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactTimesExternalInboundCalls }]
                                    },
                                    [contactTimesExternalInboundCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesInboundOtherCallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesInboundOtherCallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactTimesExternalInboundOtherCalls }]
                                    },
                                    [contactTimesExternalInboundOtherCalls]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesInboundDDICallsName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesInboundDDICallsTitle
                                        ),
                                        subMenuItems: [{ statIds: contactTimesExternalInboundDDICalls }]
                                    },
                                    [contactTimesExternalInboundDDICalls]
                                ),
                                { statIds: contactTimesInbound }
                            ]
                        },
                        [
                            contactTimesInbound,
                            contactTimesExternalInboundACDCalls,
                            contactTimesExternalInboundNonACDCalls,
                            contactTimesExternalInboundCalls,
                            contactTimesExternalInboundOtherCalls,
                            contactTimesExternalInboundDDICalls
                        ]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactTimesOutboundName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactTimesOutboundTitle),
                            subMenuItems: [{ statIds: contactTimesOutbound }]
                        },
                        [contactTimesOutbound]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactTimesVoiceName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactTimesVoiceTitle),
                            subMenuItems: [
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundOnlyName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundOnlyTitle
                                        ),
                                        subMenuItems: [
                                            ...notEmptyCategory(
                                                {
                                                    name: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundACDCallsName
                                                    ),
                                                    title: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundACDCallsTitle
                                                    ),
                                                    subMenuItems: [
                                                        { statIds: contactTimesVoiceExternalInboundACDCalls }
                                                    ]
                                                },
                                                [contactTimesVoiceExternalInboundACDCalls]
                                            ),
                                            ...notEmptyCategory(
                                                {
                                                    name: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundNonACDCallsName
                                                    ),
                                                    title: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundNonACDCallsTitle
                                                    ),
                                                    subMenuItems: [
                                                        {
                                                            statIds: contactTimesVoiceExternalInboundNonACDCalls
                                                        }
                                                    ]
                                                },
                                                [contactTimesVoiceExternalInboundNonACDCalls]
                                            ),
                                            ...notEmptyCategory(
                                                {
                                                    name: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundCallsName
                                                    ),
                                                    title: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundCallsTitle
                                                    ),
                                                    subMenuItems: [{ statIds: contactTimesVoiceExternalInboundCalls }]
                                                },
                                                [contactTimesVoiceExternalInboundCalls]
                                            ),
                                            ...notEmptyCategory(
                                                {
                                                    name: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundOtherCallsName
                                                    ),
                                                    title: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundOtherCallsTitle
                                                    ),
                                                    subMenuItems: [
                                                        { statIds: contactTimesVoiceExternalInboundOtherCalls }
                                                    ]
                                                },
                                                [contactTimesVoiceExternalInboundOtherCalls]
                                            ),
                                            ...notEmptyCategory(
                                                {
                                                    name: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundDDICallsName
                                                    ),
                                                    title: language?.get(
                                                        FieldsListLanguage.CategorySubmenuContactTimesVoiceInboundDDICallsTitle
                                                    ),
                                                    subMenuItems: [
                                                        { statIds: contactTimesVoiceExternalInboundDDICalls }
                                                    ]
                                                },
                                                [contactTimesVoiceExternalInboundDDICalls]
                                            ),
                                            { statIds: contactTimesVoiceInbound }
                                        ]
                                    },
                                    [
                                        contactTimesVoiceInbound,
                                        contactTimesVoiceExternalInboundACDCalls,
                                        contactTimesVoiceExternalInboundNonACDCalls,
                                        contactTimesVoiceExternalInboundCalls,
                                        contactTimesVoiceExternalInboundOtherCalls,
                                        contactTimesVoiceExternalInboundDDICalls
                                    ]
                                ),
                                ...notEmptyCategory(
                                    {
                                        name: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceOutboundOnlyName
                                        ),
                                        title: language?.get(
                                            FieldsListLanguage.CategorySubmenuContactTimesVoiceOutboundOnlyTitle
                                        ),
                                        subMenuItems: [{ statIds: contactTimesVoiceOutbound }]
                                    },
                                    [contactTimesVoiceOutbound]
                                ),

                                { statIds: contactTimesVoice }
                            ]
                        },
                        [
                            contactTimesVoiceInbound,
                            contactTimesVoiceOutbound,
                            contactTimesVoice,
                            contactTimesVoiceExternalInboundACDCalls,
                            contactTimesVoiceExternalInboundNonACDCalls,
                            contactTimesVoiceExternalInboundCalls,
                            contactTimesVoiceExternalInboundOtherCalls,
                            contactTimesVoiceExternalInboundDDICalls
                        ]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactTimesChatName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactTimesChatTitle),
                            subMenuItems: [
                                {
                                    ...notEmptyCategory(
                                        {
                                            name: language?.get(
                                                FieldsListLanguage.CategorySubmenuContactTimesInboundChatName
                                            ), //
                                            title: language?.get(
                                                FieldsListLanguage.CategorySubmenuContactTimesInboundChatTitle
                                            ), //
                                            subMenuItems: [{ statIds: contactTimesChatInbound }]
                                        },
                                        [contactTimesChatInbound]
                                    ),
                                    statIds: contactTimesChat
                                }
                            ]
                        },
                        [contactTimesChat, contactTimesChatInbound]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactTimesEmailName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactTimesEmailTitle),
                            subMenuItems: [
                                {
                                    ...notEmptyCategory(
                                        {
                                            name: language?.get(
                                                FieldsListLanguage.CategorySubmenuContactTimesInboundEmailName
                                            ),
                                            title: language?.get(
                                                FieldsListLanguage.CategorySubmenuContactTimesInboundEmailTitle
                                            ),
                                            subMenuItems: [{ statIds: contactTimesEmailInbound }]
                                        },
                                        [contactTimesEmailInbound]
                                    ),
                                    statIds: contactTimesEmail
                                }
                            ]
                        },
                        [contactTimesEmail, contactTimesEmailInbound]
                    ),
                    { statIds: contactTimes }
                ]
            },
            [
                contactTimesInbound,
                contactTimesOutbound,
                contactTimesVoiceInbound,
                contactTimesVoiceOutbound,
                contactTimesVoice,
                contactTimesChat,
                contactTimesChatInbound,
                contactTimesEmail,
                contactTimesEmailInbound,
                contactTimes,
                contactTimesExternalInboundACDCalls,
                contactTimesExternalInboundNonACDCalls,
                contactTimesExternalInboundCalls,
                contactTimesExternalInboundOtherCalls,
                contactTimesExternalInboundDDICalls,
                contactTimesVoiceExternalInboundACDCalls,
                contactTimesVoiceExternalInboundNonACDCalls,
                contactTimesVoiceExternalInboundCalls,
                contactTimesVoiceExternalInboundOtherCalls,
                contactTimesVoiceExternalInboundDDICalls
            ]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuFinancialName),
                title: language?.get(FieldsListLanguage.CategorySubmenuFinancialTitle),
                subMenuItems: [
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuFinancialVoiceName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuFinancialVoiceTitle),
                            subMenuItems: [{ statIds: financialVoice }]
                        },
                        [financialVoice]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuFinancialChatName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuFinancialChatTitle),
                            subMenuItems: [{ statIds: financialChat }]
                        },
                        [financialChat]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuFinancialEmailName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuFinancialEmailTitle),
                            subMenuItems: [{ statIds: financialEmail }]
                        },
                        [financialEmail]
                    ),
                    { statIds: financial }
                ]
            },
            [financialVoice, financialChat, financialEmail, financial]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuAcdCountsName),
                title: language?.get(FieldsListLanguage.CategorySubmenuAcdCountsTitle),
                subMenuItems: [
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuAcdCountsBusyCountsName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuAcdCountsBusyCountsTitle),
                            subMenuItems: [{ statIds: ACDCountsBusyCounts }]
                        },
                        [ACDCountsBusyCounts]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuAcdCountsNotAvailableCodeCountsName),
                            title: language?.get(
                                FieldsListLanguage.CategorySubmenuAcdCountsNotAvailableCodeCountsTitle
                            ),
                            subMenuItems: [{ statIds: ACDCountsNotAvailableCodeCounts }]
                        },
                        [ACDCountsNotAvailableCodeCounts]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesAcdName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuContactPercentagesAcdTitle),
                            subMenuItems: [{ statIds: ACDPercentages }]
                        },
                        [ACDPercentages]
                    ),
                    { statIds: ACDCounts }
                ]
            },
            [ACDCountsBusyCounts, ACDCountsNotAvailableCodeCounts, ACDPercentages, ACDCounts]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuAcdTimesName),
                title: language?.get(FieldsListLanguage.CategorySubmenuAcdTimesTitle),
                subMenuItems: [
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuAcdTimesBusyTimesName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuAcdTimesBusyTimesTitle),
                            subMenuItems: [{ statIds: ACDTimesBusyTimes }]
                        },
                        [ACDTimesBusyTimes]
                    ),
                    ...notEmptyCategory(
                        {
                            name: language?.get(FieldsListLanguage.CategorySubmenuAcdTimesNotAvailableCodeTimesName),
                            title: language?.get(FieldsListLanguage.CategorySubmenuAcdTimesNotAvailableCodeTimesTitle),
                            subMenuItems: [{ statIds: ACDTimesNotAvailableCodeTimes }]
                        },
                        [ACDTimesNotAvailableCodeTimes]
                    ),
                    { statIds: ACDTimes }
                ]
            },
            [ACDTimesBusyTimes, ACDTimesNotAvailableCodeTimes, ACDTimes]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuDndStatisticsName),
                title: language?.get(FieldsListLanguage.CategorySubmenuDndStatisticsTitle),
                subMenuItems: [{ statIds: DNDStatistics }]
            },
            [DNDStatistics]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuStatesName),
                title: language?.get(FieldsListLanguage.CategorySubmenuStatesTitle),
                subMenuItems: [{ statIds: states }]
            },
            [states]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuTotalFraudDetectionName),
                title: language?.get(FieldsListLanguage.CategorySubmenuTotalFraudDetectionTitle),
                subMenuItems: [{ statIds: totalFraudDetection }]
            },
            [totalFraudDetection]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuReportSettingsName),
                title: language?.get(FieldsListLanguage.CategorySubmenuReportSettingsTitle),
                subMenuItems: [{ statIds: reportSettings }]
            },
            [reportSettings]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuUserContentName),
                title: language?.get(FieldsListLanguage.CategorySubmenuUserContentTitle),
                subMenuItems: [{ statIds: userContent }]
            },
            [userContent]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuMiscellaneousName),
                title: language?.get(FieldsListLanguage.CategorySubmenuMiscellaneousTitle),
                subMenuItems: [{ statIds: miscellaneous }]
            },
            [miscellaneous]
        ),
        ...notEmptyCategory(
            {
                name: language?.get(FieldsListLanguage.CategorySubmenuDiagnosticValuesName),
                title: language?.get(FieldsListLanguage.CategorySubmenuDiagnosticValuesTitle),
                subMenuItems: [{ statIds: diagnosticValues }]
            },
            [diagnosticValues]
        )
    ] as AddMenuItem[]
}
